// Extend this array to add new training categories.
// The `key` is used as the stored enum value;
// The `label` is the displayed label in the editing interface.
const TRAINING_CATEGORIES = [
  { key: "it", label: { de: "IT-Kurs", en: "IT course" } },
  { key: "language", label: { de: "Sprache", en: "Language" } },
  { key: "health", label: { de: "Gesundheit", en: "Health" } },
  { key: "web", label: { de: "Web-Optimierung", en: "Web Optimization" } },
  { key: "lang", label: { de: "Sprachen", en: "Languages" } },
  {
    key: "management",
    label: { de: "Für Führungskräfte", en: "For Management" },
  },
  {
    key: "retirement",
    label: { de: "Altersvorsorge", en: "Retirement Planning" },
  },
  {
    key: "department",
    label: { de: "Aus den Fachebereichen", en: "From the Departments" },
  },
  {
    key: "research",
    label: { de: "Forschungsmanagement", en: "Research Management" },
  },
];

export default TRAINING_CATEGORIES;
